import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { JobFormSaqTabPropTypes, JobFormSaqTabDefaultProps } from 'src/components/JobFormSaqTab/propTypes';
import { useDeleteJobExternalStakeholder } from 'src/hooks/jobExternalStakeholder/useDeleteJobExternalStakeholder';
import { useExternalJobStakeholders } from 'src/hooks/jobExternalStakeholder/useJobExternalStakeholders';

import {
  JobExternalStakeholderRoleTranslation,
  JobExternalStakeholdersPopupType,
} from 'src/components/CapBox/constants';
import { ServiceType } from 'src/components/JobFormSaqTab/constants';
import { JobExternalStakeholdersPopup } from 'src/components/JobExternalStakeholdersPopup/JobExternalStakeholdersPopup';

import Styles from 'src/components/JobForm/JobForm.styles';
import s from './JobFormSaqTab.styles';

const JobFormSaqTab = ({
  auth,
  companyTypes,
  job,
  jobId,
  jobStatus
}) => {
  const { t } = useTranslation();

  // TODO: Refactor do not duplicate the code
  const {
    data: jobExternalStakeholdersData,
    loading: isLoadingJobExternalStakeholders,
    refetch: refetchJobExternalStakeholders
  } = useExternalJobStakeholders(jobId, ServiceType);

  const {
    isLoading: isDeletingJobExternalStakeholder,
    deleteJobExternalStakeholderCallback: deleteJobExternalStakeholder,
  } = useDeleteJobExternalStakeholder();

  const [jobExternalStakeholders, setJobExternalStakeholders] = useState([]);
  const [jobExternalStakeholdersPopupType, setJobExternalStakeholdersPopupType] = useState(null);

  useEffect(() => {
    setJobExternalStakeholders(jobExternalStakeholdersData ? jobExternalStakeholdersData?.jobExternalStakeholders : []);
  }, [jobExternalStakeholdersData]);

  useEffect(() => {
    if(!isLoadingJobExternalStakeholders) {
      refetchJobExternalStakeholders();
    }
  }, [jobStatus]);

  const isExternalStakeholdersEditable = !(auth.isClientUser || auth.isFactoryUser || auth.isVendorUser);

  const jobExternalStakeholdersPopup = (
    <JobExternalStakeholdersPopup
      companyTypes={companyTypes}
      disabled={isLoadingJobExternalStakeholders}
      excludedUsersIds={jobExternalStakeholders.map(user => user.userId)}
      job={job}
      jobId={jobId}
      onClose={() => setJobExternalStakeholdersPopupType(null)}
      onSubmit={refetchJobExternalStakeholders}
      serviceType={ServiceType}
      type={jobExternalStakeholdersPopupType}
    />
  );

  return (
    <s.Wrapper>
      {jobExternalStakeholdersPopupType && jobExternalStakeholdersPopup}

      <s.Left>
        <s.Title>{t('SAQ_MANAGEMENT')}</s.Title>

        <s.ExternalCAPUsersWrapper>
          <Styles.BlockHeader>{t('EXTERNAL_SAQ_USERS')}</Styles.BlockHeader>
          {isExternalStakeholdersEditable &&
          <Styles.AddButtonWrapper
            onClick={() => setJobExternalStakeholdersPopupType(JobExternalStakeholdersPopupType.AddExisting)}
          >
            <Styles.AddButton name="plus"/>
            <Styles.AddButtonLabel>{t('USER')}</Styles.AddButtonLabel>
          </Styles.AddButtonWrapper>
          }
        </s.ExternalCAPUsersWrapper>
        <s.Table>
          <thead>
          <tr>
            <td>{t('NAME')}</td>
            <td>{t('EMAIL')}</td>
            <td>{t('AFFILIATION')}</td>
            <td>{t('ACTION')}</td>
          </tr>
          </thead>
          <tbody>
          {jobExternalStakeholders.map(stakeholder => (
            <tr key={`stakeholder-${stakeholder.id}`}>
              <td>{`${stakeholder.user.firstName} ${stakeholder.user.lastName}`}</td>
              <td>{stakeholder.user.email}</td>
              <td>{t(JobExternalStakeholderRoleTranslation[stakeholder.role])}</td>
              <td>
              {isExternalStakeholdersEditable &&
                <Styles.ActionButton
                  disabled={isDeletingJobExternalStakeholder || isLoadingJobExternalStakeholders}
                  isDeleteButton
                  onClick={async () => {
                    const response = await deleteJobExternalStakeholder({
                      id: stakeholder.id,
                    });

                    if (response) {
                      refetchJobExternalStakeholders();
                    }
                  }}
                  sm
                  solid
                  type="button"
                >
                  {t('DELETE')}
                </Styles.ActionButton>
              }
              </td>
            </tr>
          ))}
          </tbody>
        </s.Table>
      </s.Left>
    </s.Wrapper>
  );
};

JobFormSaqTab.propTypes = JobFormSaqTabPropTypes;
JobFormSaqTab.defaultProps = JobFormSaqTabDefaultProps;

export default React.memo(JobFormSaqTab);
